import { useMutation } from "@tanstack/react-query"
import apiInputService from "services/apiInputService"

const deleteActivityItem = async (activityItemId: string, reason?: string) => {
    const url = `/activityItem/${activityItemId}${`?reason=${reason}`}`;
    const { data } = await apiInputService.delete(url);
    return data;
}

export const useDeleteActivityItem = (options?: any) => {
    return useMutation(
        ({ id, reason }: { id: string; reason?: string }) => deleteActivityItem(id, reason), 
        {
            ...options,
        }
    );
}